import Helpers from '..';

const shouldInjectInlineAndSideAds = (options) => {
  if (!Helpers.isBetweenTwoTextBlocks({ ...options })) return false;
  if (!Helpers.isConfigValid(options)) return false;

  const {
    currentRuleInjectedComponentCount: adCount,
    currentRuleComponentTypeWordCount,
    props: {
      adSettings:
        {
          numberOfWordsBetweenInlineDesktopAds,
          numberOfWordsForFirstInjectionDesktop,
          minNumOfWordsAfterLastInlineAdDesktop,
        },
    },
  } = options;

  const enoughWordsBetweenAds = currentRuleComponentTypeWordCount >= numberOfWordsBetweenInlineDesktopAds;
  const wordCountFromCurrIdxToEnd = Helpers.getWordCountFromCurrentIdxToEnd({ ...options });
  const enoughWordsAfterTheAd = wordCountFromCurrIdxToEnd >= minNumOfWordsAfterLastInlineAdDesktop;

  if (adCount === 0) {
    return (currentRuleComponentTypeWordCount >= numberOfWordsForFirstInjectionDesktop) && enoughWordsAfterTheAd;
  }

  return enoughWordsBetweenAds && enoughWordsAfterTheAd;
};

export default shouldInjectInlineAndSideAds;
